import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import { Box, Paper, IconButton, TextField } from '@mui/material';
import { CheckBox, Delete } from '@mui/icons-material';

const CheckboxComponent = (props: any) => {
  const { node, updateAttributes, deleteNode } = props;
  const { content } = node.attrs;

  return (
    <NodeViewWrapper>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          my: 2,
          backgroundColor: '#f5f5f5',
          border: '2px solid #ff9800',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <CheckBox color="warning" />
          <strong>Чекбокс</strong>
          <IconButton
            size="small"
            color="error"
            onClick={deleteNode}
            sx={{ ml: 'auto' }}
          >
            <Delete />
          </IconButton>
        </Box>
        <TextField
          fullWidth
          multiline
          minRows={2}
          maxRows={5}
          size="small"
          label="Текст чекбокса"
          value={content || ''}
          onChange={(e) => updateAttributes({ content: e.target.value })}
        />
      </Paper>
    </NodeViewWrapper>
  );
};

export const CheckboxBlock = Node.create({
  name: 'checkboxBlock',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      content: { default: '' },
      is_blur: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="checkboxBlock"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-type': 'checkboxBlock' }, HTMLAttributes),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CheckboxComponent);
  },

  // @ts-ignore - Tiptap type issue with custom commands
  addCommands() {
    return {
      insertCheckboxBlock:
        (attrs: { content?: string; is_blur?: boolean }) =>
        ({ commands }: any) =>
          commands.insertContent({
            type: this.name,
            attrs,
          }),
    };
  },
});
